import { render, staticRenderFns } from "./SettingsUnions.vue?vue&type=template&id=9900e98e&scoped=true"
import script from "./SettingsUnions.vue?vue&type=script&lang=js"
export * from "./SettingsUnions.vue?vue&type=script&lang=js"
import style0 from "./SettingsUnions.vue?vue&type=style&index=0&id=9900e98e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9900e98e",
  null
  
)

export default component.exports